export const BenefitCouponIcon = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M42 14H8.40002V37.8H42V29.4C40.067 29.4 38.5 27.833 38.5 25.9C38.5 23.967 40.067 22.4 42 22.4V14Z"
      fill="#8A8A8A"
    />
    <path
      d="M12.6 18.2H46.2V26.6C44.267 26.6 42.7 28.167 42.7 30.1C42.7 32.0329 44.267 33.6 46.2 33.6V42H12.6V33.6C14.533 33.6 16.1 32.0329 16.1 30.1C16.1 28.167 14.533 26.6 12.6 26.6V18.2Z"
      fill="black"
    />
    <path
      d="M24.202 33.8122L33.1115 24.9027L34.5964 26.3876L25.6869 35.2971L24.202 33.8122Z"
      fill="white"
    />
    <path
      d="M27.002 26.3026C27.002 27.0758 26.3752 27.7026 25.602 27.7026C24.8288 27.7026 24.202 27.0758 24.202 26.3026C24.202 25.5294 24.8288 24.9026 25.602 24.9026C26.3752 24.9026 27.002 25.5294 27.002 26.3026Z"
      fill="white"
    />
    <path
      d="M34.5953 33.8973C34.5953 34.6705 33.9685 35.2973 33.1953 35.2973C32.4221 35.2973 31.7953 34.6705 31.7953 33.8973C31.7953 33.1241 32.4221 32.4973 33.1953 32.4973C33.9685 32.4973 34.5953 33.1241 34.5953 33.8973Z"
      fill="white"
    />
  </svg>
);
